/**
 * @fileoverview Primary contact section header and field rows for ContactsData.
 */

import React from "react";
import { PrimaryMotherLastNameField, PrimaryContactIdentityFields } from "./PrimaryContactIdentityFields";
import { PrimaryContactPhoneFields } from "./PrimaryContactPhoneFields";
import { PrimaryContactProfileFields } from "./PrimaryContactProfileFields";
import styles from "./ContactsData.module.css";

const PrimaryContactFields = ({ form, onFieldChange }) => {
  const { t } = form;

  return (
    <>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>
          {t("components.contactsData.title")}
        </span>
        <div className={styles.sectionDivider}></div>
      </div>
      <p className={styles.mainContactLabel}>
        {t("components.contactsData.mainContactLabel")}
      </p>
      <PrimaryContactIdentityFields form={form} onFieldChange={onFieldChange} />
      <div className={styles.inputRow}>
        <PrimaryMotherLastNameField form={form} />
        <PrimaryContactPhoneFields form={form} />
      </div>
      <PrimaryContactProfileFields form={form} onFieldChange={onFieldChange} />
    </>
  );
};

export default PrimaryContactFields;
